export const ANNONCE_COLLECTION = "Annonces";
export const USERS_COLLECTION = "Users";
export const TMP_USERS_COLLECTION = "Tmp_users";
export const REQUESTS_COLLECTION = "Requests";
export const TMP_REQUESTS_COLLECTION = "Tmp_requests";
export const PRESS_COLLECTION = "PressSpace";